import { render, staticRenderFns } from "./ClientRefs.vue?vue&type=template&id=097eac98&scoped=true&"
import script from "./ClientRefs.vue?vue&type=script&lang=js&"
export * from "./ClientRefs.vue?vue&type=script&lang=js&"
import style0 from "./ClientRefs.vue?vue&type=style&index=0&id=097eac98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097eac98",
  null
  
)

export default component.exports